import React from 'react';
import Background from './components/Background';
import './App.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faUser, faBriefcase, faCode } from '@fortawesome/free-solid-svg-icons'

library.add(faEnvelope, faGithub, faLinkedin, faUser, faBriefcase, faCode)

function App() {
  return (
    <div className="app">
      <Background />
    </div>
  );
}

export default App;